export const ITR_moveBackConvUIReducer = {
  ITR_moveBackConvUI: (state, action) => {},
};
